
    <div class="h-80" fxFlex>
      <ngx-charts-area-chart
        *fuseIfOnDom
        [results]="results"
        [scheme]="conf.scheme"
        [gradient]="conf.gradient"
        [xAxis]="conf.xAxis"
        [yAxis]="conf.yAxis"
        [legend]="conf.legend"
        [showXAxisLabel]="conf.showXAxisLabel"
        [showYAxisLabel]="conf.showYAxisLabel"
        [xAxisLabel]="conf.xAxisLabel"
        [yAxisLabel]="conf.yAxisLabel"
        [curve]="conf.curve">
      </ngx-charts-area-chart>
    </div>
  